import { PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled, { css } from 'styled-components'

import { flexboxGapStyles } from '../../../../../../lib/styles/flexbox-gap'

const commonButtonStyles = css`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 500;
  width: 100%;
  max-width: 250px;
`

export const SaveButton = styled(PrimaryButton)`
  ${commonButtonStyles};
  font-weight: 700;
  border-radius: 8px;
`

export const CancelButton = styled(SecondaryButton)`
  ${commonButtonStyles};
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: underline;
  border: none;
  background: transparent;
  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.text.primary};
    background: transparent;
  }
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 50px;
  margin-top: 2rem;
  ${flexboxGapStyles('10px')};
`
export const Form = styled.form`
  width: 100%;
`

export const Email = styled.a`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
  color: ${({ theme }) => theme.colors.brand.orange};
  white-space: nowrap;
`
